import Chart from 'react-apexcharts';

function LineRangeAreaChart({
  title = '',
  categories = [],
  series = [],
  width = '100%',
  height = 280,
  stroke = {},
  markers = {},
  prefix = '',
  suffix = '',
  decimalPoints = 0,
  yAxisDecimalPoints = 0,
  yAxisLabel = '',
  min = undefined,
  max = undefined,
}) {
  const formatValue = (val) => {
    if (typeof val !== 'number') return val;
    return `${prefix}${val.toFixed(decimalPoints)}${suffix}`;
  };

  // Flatten all values to find global min and max
  const allValues = series?.flatMap((x) => x.data?.flatMap((y) => (Array.isArray(y.y) ? y.y : [y.y])));

  const minValue = Math.min(...allValues);
  const maxValue = Math.max(...allValues);

  const options = {
    title: { text: title },
    chart: { animations: { enabled: false } },
    xaxis: {
      categories,
      labels: {
        offsetY: 5,
        rotate: -45,
        rotateAlways: true,
      },
    },
    yaxis: [
      {
        forceNiceScale: false,
        max,
        min: (min ?? minValue),
        labels: {
          formatter: (value) => {
            let dp = yAxisDecimalPoints;

            if (maxValue - minValue <= 3 && yAxisDecimalPoints === 0) {
              dp = 1;
            }

            if (maxValue - minValue <= 0.25 && yAxisDecimalPoints === 0) {
              dp = 2;
            }

            return `${prefix}${value.toFixed(dp)}${suffix}`;
          },
        },
        title: {
          text: yAxisLabel,
        },
      },
    ],
    grid: {
      padding: { left: 20 },
    },
    dataLabels: {
      enabled: false,
    },
    stroke,
    markers: {
      ...markers,
      hover: {
        size: 6,
      },
    },
    tooltip: {
      shared: false,
      intersect: true,
      custom({ dataPointIndex, w }) {
        const { initialSeries } = w.globals;
        const values = initialSeries.map((s) => {
          const { name } = s;
          const val = s.data[dataPointIndex]?.y;

          if (s.type === 'rangeArea' && Array.isArray(val)) {
            const [rangeMin, rangeMax] = val;
            return `<li><b>${name}</b>: ${formatValue(rangeMin)} to ${formatValue(rangeMax)}</li>`;
          }

          return `<li><b>${name}</b>: ${formatValue(val)}</li>`;
        });

        return `<div style="padding: 10px"><ul>${values.join('')}</ul></div>`;
      },
    },
  };

  return <Chart options={options} series={series} type="rangeArea" width={width} height={height} />;
}

export default LineRangeAreaChart;
